import React, {useEffect} from "react";

import {DEFAULT_TEMPLATE_VERSION, MOBILE_TEMPLATE_VERSION, PLANNER_PAGE} from "@/utils/constants";
import {connect, useDispatch} from "react-redux";
import WrapperContainer from "@/components/WrapperContainer";
import HomePage from "@/components/responsive/planner/HomePage";
import {setAxiosServerConfig} from "@/services/ApiCaller/apiCallerSSR";
import {getCustomMenu} from "@/services/menuServices";
import cookie from "cookie"
import ResponsiveLayout from "@/components/responsive/ResponsiveLayout";
import {getDefaultMenu} from "@/redux/reducers/Default/header/headerActions";
import {useRouter} from "next/router";
import HeadDetails from "@/components/Default/Layout/Head";
import {getBuildId} from "@/utils/communUtil";
import Scripts from "@/components/Default/Layout/Head/Scripts";
import Script from "next/script";
import {getPlannerConfiguration} from "@/services/plannerServices";
import {initAppDataKeyValues} from "@/animations/Default/commonPage";
import {getTrackingData} from "@/redux/reducers/Default/tracking/trackingActions";

export const Home = ({
                         templateVersion,
                         menuItems,
                         aboveMenuItems,
                         userAgent,
                         backgroundPictures,
                         isDQENormalisationActive,
                         shopCircleVersion,
                         logoVersion,
                         isWebloyaltyActive,
                         mvcUrl,
                         footerTrackingScopeData,
                         headerTrackingScopeData
                     }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getDefaultMenu(templateVersion, userAgent));
        initAppDataKeyValues([], [], [], PLANNER_PAGE, '', isDQENormalisationActive, shopCircleVersion, logoVersion, null, '', '', isWebloyaltyActive, templateVersion);
        dispatch(getTrackingData(mvcUrl))
    }, [])
    const router = useRouter()
    const pathName = router.pathname
    return (
        <WrapperContainer context={PLANNER_PAGE} templateVersion={templateVersion}>
            <HeadDetails title={'But - Accueil planner 3D'}>
                <link rel="stylesheet" href={"/assets/css/responsive/style.css?v=" + getBuildId()}/>
                <link rel="stylesheet" href={"/assets/css/responsive/homePage.css?v=" + getBuildId()}/>
                <link rel="stylesheet" href={"/assets/css/responsive/kitchenChoicePage.css?v=" + getBuildId()}/>
                {templateVersion === DEFAULT_TEMPLATE_VERSION &&
                    <link rel="stylesheet" href={"/assets/css/default/headerFooter.css?v=" + getBuildId()}/>}
                {templateVersion === MOBILE_TEMPLATE_VERSION &&
                    <link rel="stylesheet" href={"/assets/css/mobile/headerFooter.css?v=" + getBuildId()}/>}
            </HeadDetails>
            <Scripts>
                <Script src="/assets/js/imageMapResizer.min.js" strategy="beforeInteractive"/>
                <Script src="/assets/js/owl.carousel.min.js" strategy="beforeInteractive"/>
                <Script type="text/tc_privacy" data-category="3" src="/assets/js/Default/octipasMerchLibraryConfig.js"/>
            </Scripts>
            <ResponsiveLayout menuItems={menuItems} aboveMenuItems={aboveMenuItems} templateVersion={templateVersion}
                              headerTrackingScopeData={headerTrackingScopeData}
                              footerTrackingScopeData={footerTrackingScopeData}
                              pathName={pathName} currentStep={PLANNER_PAGE} ssr={true}
                              shopCircleVersion={shopCircleVersion}>
                <HomePage kitchenPictures={backgroundPictures} templateVersion={templateVersion}/>
            </ResponsiveLayout>
        </WrapperContainer>

    )
};

export async function getServerSideProps({req, res}) {
    setAxiosServerConfig(res)
    const deviceType = DEFAULT_TEMPLATE_VERSION;
    const userAgent = req.headers['user-agent'];
    const parsedCookies = req.headers.cookie ? cookie.parse(req.headers.cookie) : null;
    const cUserID = (parsedCookies && parsedCookies.CUserID) ? parsedCookies.CUserID : '';
    const result = await Promise.all([
        getCustomMenu(deviceType, userAgent, null, true, cUserID, true, req.url),
        getPlannerConfiguration(req.url)
    ]);
    const plannerPageData = result[1]
    const menuData = result[0]
    return {
        props: {
            menuItems: menuData.menuItems.values,
            aboveMenuItems: menuData.aboveMenuItems.values,
            userAgent: userAgent,
            backgroundPictures: plannerPageData.backgroundPhoto,
            isWebloyaltyActive: plannerPageData.isWebloyaltyActive,
            isDQENormalisationActive: plannerPageData.isDQENormalisationActive,
            shopCircleVersion: plannerPageData.shopCircleVersion,
            logoVersion: plannerPageData.logoVersion,
            mvcUrl: plannerPageData.mvcUrl,
            headerTrackingScopeData: plannerPageData.headerTrackingScopeData,
            footerTrackingScopeData: plannerPageData.footerTrackingScopeData,
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        menuItems: (!state.menu.isDefaultMenu) ? ownProps.menuItems : state.menu.menuItems.values,
    }
}
export default connect(mapStateToProps, null)(Home);
